import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/yellow';
import widgetsHelper from 'utils/getWidget.helper';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    toggleMode = mode => {
        this.setState({mode: mode});
    };
    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: [],
            loader: true
        };
        this.widgetsHelper = widgetsHelper;
    }

    componentDidMount() {
        this.widgetsHelper.getWidgets.call(this);
    }
}
